import React from "react";
import { PieChart } from "@mui/x-charts/PieChart";

const CustomPieChart = ({
  dataset,
  width = 250,
  height = 250,
  innerRadius = 30,
  outerRadius = 90,
  paddingAngle = 2,
  cornerRadius = 2,
  startAngle = 0,
  endAngle = 360,
  legend = false,
}) => {
  return (
    <PieChart
      sx={{ alignSelf: "center", alignItems: "center" }}
      series={[
        {
          data: dataset,
          innerRadius: innerRadius,
          outerRadius,
          paddingAngle,
          cornerRadius,
          startAngle,
          endAngle,
          cx: width / 2,
          cy: height / 2,
        },
      ]}
      width={width} // Larghezza dinamica
      height={height} // Altezza dinamica
      slotProps={{
        legend: {
          direction: "row",
          position: { vertical: "bottom", horizontal: "middle" },
        },
      }}
    />
  );
};

export default CustomPieChart;
